import {
  UserRound,
  Cog,
  BriefcaseBusiness,
  Users,
  Calculator,
  WalletCards,
  Banknote,
  FolderKanban,
  ListTodo,
  CalendarDays,
  CalendarX,
  Receipt,
  ClipboardList,
  FileDown,
  FileText,
  CloudUpload,
  UserPlus,
  MessageSquareText,
  CalendarClock,
  BookUser,
  SlidersHorizontal,
  MessageCircle,
  GraduationCap,
} from "lucide-react";
//salary pages for testing branch merged  
import type { LucideIcon } from "lucide-react";
import { UserRole } from "../../util/roles";

export interface SidebarItem {
  label: string;
  url: string;
  icon: LucideIcon;
  color?: string;
  roles: number[];
  moduleKey?: string;
}

const items = [
  {
    label: "Profile",
    url: "profile",
    icon: UserRound,
    color: "text-black dark:text-white",
    roles: [
      UserRole.USER,
      UserRole.ADMIN,
      UserRole.SYS_ADMIN,
      UserRole.MANAGER,
    ],
    moduleKey: "MY_PROFILE",
  },
  {
    label: "Org Settings",
    url: "org-settings",
    icon: Cog,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.SYS_ADMIN],
    moduleKey: "ORG_SETTINGS",
  },
  {
    label: "Inventory",
    url: "inventories",
    icon: BriefcaseBusiness,
    color: "text-black dark:text-white",
    roles: [
      UserRole.USER,
      UserRole.ADMIN,
      UserRole.SYS_ADMIN,
      UserRole.MANAGER,
    ],
    moduleKey: "INVENTORY",
  },
  {
    label: "Employees",
    url: "employees",
    icon: Users,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "EMPLOYEES",
  },
  {
    label: "Tax Configure",
    url: "taxConfig",
    icon: Calculator,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "TAX_CONFIG",
  },
  {
    label: "Salary Structure",
    url: "salaryStructure",
    icon: WalletCards,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "SALARY_STRUCTURE",
  },
  {
    label: "Salary",
    url: "salary-list",
    icon: Banknote,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "SALARY",
  },

  // {
  //   label: "Generate Payroll",
  //   url: "generate-payroll",
  //   icon: Banknote,
  //   color: "text-black dark:text-white",
  //   roles: [UserRole.ADMIN],
  // },

  // {
  //   label: "Form 16",
  //   url: "form-16",
  //   icon: Banknote,
  //   color: "text-black dark:text-white",
  //   roles: [UserRole.ADMIN],
  // },

  {
    label: "Projects",
    url: "projects",
    icon: FolderKanban,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.MANAGER],
    moduleKey: "PROJECTS",
  },
{
    label: "Project Chat",
    url: "chat", 
    icon: MessageCircle,
    color: "text-black dark:text-white",
    roles: [
      UserRole.USER,
      // UserRole.ADMIN,
      // UserRole.SYS_ADMIN,
      // UserRole.MANAGER,
    ],
    moduleKey: "PROJECT_CHAT", // Ensure your JWT payload has this module access if you use ModuleProtectedRoute
  },
  {
    label: "Training & Exercise",
    url: "training", 
    icon: GraduationCap,
    color: "text-black dark:text-white",
    roles: [
      UserRole.USER,
      UserRole.ADMIN,
      UserRole.SYS_ADMIN,
      UserRole.MANAGER,
    ],
    moduleKey: "TRAINING_EXERCISE",
  },
  {
    label: "Tasks",
    url: "tasks",
    icon: ListTodo,
    color: "text-black dark:text-white",
    roles: [UserRole.USER, UserRole.ADMIN, UserRole.MANAGER],
    moduleKey: "TASKS",
  },

  {
    label: "Holiday",
    url: "holidays",
    icon: CalendarDays,
    color: "text-black dark:text-white",
    roles: [
      UserRole.USER,
      UserRole.ADMIN,
      UserRole.SYS_ADMIN,
      UserRole.MANAGER,
    ],
    moduleKey: "HOLIDAY",
  },

  {
    label: "Expenses",
    url: "reimbursement",
    icon: Receipt,
    color: "text-black dark:text-white",
    roles: [UserRole.USER, UserRole.ADMIN, UserRole.SYS_ADMIN],
    moduleKey: "REIMBURSEMENT",
  },

  {
    label: "Leave",
    url: "leaves",
    icon: CalendarX,
    color: "text-black dark:text-white",
    roles: [
      UserRole.USER,
      UserRole.ADMIN,
      UserRole.SYS_ADMIN,
      UserRole.MANAGER,
    ],
    moduleKey: "LEAVE",
  },

  {
    label: "Time Sheet",
    url: "timesheet",
    icon: ClipboardList,
    color: "text-black dark:text-white",
    roles: [UserRole.USER, UserRole.ADMIN, UserRole.MANAGER],
    moduleKey: "TIMESHEETS",
  },

  {
    label: "Export Time Sheet",
    url: "export-timesheet",
    icon: FileDown,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.MANAGER],
    moduleKey: "TIMESHEETS",
  },

  {
    label: "Generate Docs",
    url: "generate-docs",
    icon: FileText,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "GENERATE_DOCS",
  },

  {
    label: "Upload",
    url: "upload",
    icon: CloudUpload,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "UPLOAD",
  },

  {
    label: "Registration",
    url: "register",
    icon: UserPlus,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN],
    moduleKey: "REGISTRATION",
  },

  {
    label: "Review",
    url: "feedback",
    icon: MessageSquareText,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.MANAGER, UserRole.USER, UserRole.SYS_ADMIN],
    moduleKey: "FEEDBACK",
  },

  {
    label: "Shift Management",
    url: "shift-configuration",
    icon: CalendarClock,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.MANAGER],
    moduleKey: "SHIFT_MANAGEMENT",
  },

  {
    label: "Roster",
    url: "roster",
    icon: BookUser,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.MANAGER],
    moduleKey: "ROSTER",
  },
  {
    label: "Admin Config",
    url: "admin-config",
    icon: SlidersHorizontal,
    color: "text-black dark:text-white",
    roles: [UserRole.ADMIN, UserRole.SYS_ADMIN],
  },
] as SidebarItem[];

export default items;

// 1 - users
// 2 - admin
// 3 - sys-admin
// 4 - manager